import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import RadioButton from '../../blocks/radio-button/RadioButton';
import { saveSectionChanges, clearSectionMessages, test } from '../../actions/participant-action';
import './style.css';


class UserSections extends Component {
  state = {
    idSectionData: 25
  };

  showTimeoutId = null;
  hideTimeoutId = null;

  onCheckChange() {
    let that = this;
    clearTimeout(this.showTimeoutId);
    this.showTimeoutId = setTimeout(() => {
      let eventBranchIds = [];
      that.props.allSections.map(section => {
        if (that.refs[section.id].refs.radiobutton.checked) {
          eventBranchIds.push(section.id);
        }
        return null;
      });
      that.props.saveSectionChanges(eventBranchIds);
      clearTimeout(that.hideTimeoutId);
      that.hideTimeoutId = setTimeout(() => {
        that.props.clearSectionMessages();
      }, 10000);
    }, 500)
  }

  onCancel() {
    this.props.saveSectionChanges([]);
    this.props.allSections.map(section => {
      this.refs[section.id].refs.radiobutton.checked = false;
      return null;
    });
  }

  render() {
    let confirmMenu = null;
    let that = this;

    if (this.props.participantView.userShortView) {
      if (this.props.participantView.approved) {
        const sectionClasses = this.props.sectionStyleClasses ?
          'user-section__element ' + this.props.sectionStyleClasses.join(' ') :
          'user-section__element';
        let sections = this.props.allSections.map(section => {
          let checked = false;
          if (Array.isArray(that.props.userSections)) {
            checked = that.props.userSections.filter(userSection => (
                    section.id === userSection
                )).length > 0;
          } else {
            if (that.props.userSections.get(section.id) != null) {
              checked = true;
            }
          }
          return <RadioButton
              key={section.id}
              name='user-section__event-branch'
              title={section.name}
              inputId={section.id}
              ref={section.id}
              onChangeCallback={this.onCheckChange.bind(this)}
              classStyle={sectionClasses}
              checked={checked}
          />;
        });
        const sectionsClasses = this.props.sectionsStyleClasses ?
          'user-section__elements-container ' + this.props.sectionsStyleClasses.join(' ') :
          'user-section__elements-container';
        confirmMenu = (
          <form
            className='user-section'
            ref='form'
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className={sectionsClasses}>
              {sections}
            </div>
            {
              this.props.userSections.length > 0 ?
              (<div>
                <button
                className='user-section__submit-btn'
                type='submit'
                onClick={this.onCancel.bind(this)}
                >
                Отказаться от участия
                </button>
              </div>) : null
            }
            <div className='user-section__hint user-section__hint_success'>
              {this.props.successMessage}
            </div>
            <div className='user-section__hint user-section__hint_warning'>
              {this.props.warningMessage}
            </div>
          </form>
        );
      } else {
        confirmMenu = (
          <div className='user-section'>
            <div className='user-section__title user-section__title_not-approved'>Заявка находится на рассмотрении</div>
          </div>
        );
      }
    }
    return (
      <div>
        {confirmMenu}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userSections: state.participant.userSections,
  allSections: state.participant.allSections,
  participantView: state.participant.participantView,
  successMessage: state.participant.successMessage,
  warningMessage: state.participant.warningMessage
});

const mapDispatchToProps = (dispatch) => ({
  saveSectionChanges: bindActionCreators(saveSectionChanges, dispatch),
  clearSectionMessages: bindActionCreators(clearSectionMessages, dispatch),
  test: bindActionCreators(test, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserSections);



// WEBPACK FOOTER //
// ./src/blocks/user-sections/UserSections.js